<div class="asset-class-strategy-filter-wrapper">
  <h4 class="c11n-text-sm c11n-space-stack-2x">{{ filter.assetCaas.asset }}</h4>
  <div class="c11n-space-stack-4x c11n-space--force">
    <c11n-radio-group groupId="FilterBY" errorText="Please choose one." hideLegend="false" legendText="{{ filterByLabHeader+' '+filter.assetCaas.asset }}"
                      hasError="false"
                      (stateChange)="onFilterByChange($event)" variant="default" hasCustomHintError="false">
      <div class="storybook-horizontal-radios">
        <c11n-radio [labelText]=filter.assetCaas.equity>
          <input c11nRadioInput id="equity" type="radio" name="assetClass" [value]=filter.assetCaas.equity
                 [checked]=filter.filterByLevel1.equity.value />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.multiAsset>
          <input c11nRadioInput id="multiAsset" type="radio"  name="assetClass" [disabled]="selectedProductType === filter.assetCaas.etf && filterByModel && !filterByModel.MulAsset" [value]=filter.assetCaas.multiAsset
                 [checked]=filter.filterByLevel1.multiAsset.value />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.fixedIncome>
          <input c11nRadioInput id="fixedIncome" type="radio" name="assetClass" [value]=filter.assetCaas.fixedIncome
                 [checked]=filter.filterByLevel1.fixedIncome.value />
        </c11n-radio>
        <c11n-radio [labelText]=filter.assetCaas.cashEquivalent>
          <input c11nRadioInput id="cashEquivalent" type="radio" name="assetClass" [disabled]="selectedProductType === filter.assetCaas.etf && filterByModel && !filterByModel.CashEqv"
                 [value]=filter.assetCaas.cashEquivalent [checked]=filter.filterByLevel1.cashEquivalent.value />
        </c11n-radio>
      </div>
    </c11n-radio-group>
  </div>
</div>
<div class="asset-class-strategy-filter-wrapper">
  <h4 class="c11n-text-sm c11n-space-stack-2x">
    {{ filter.assetCaas.strategy }}
    <a role="button" c11n-link class="accessibility-no-border" variant="secondary-reinforced"
       href="javascript:void(0)" aria-label="Strategies Information Modal"
       (click)="strategyModalDialog.openModalDialog()">
      <c11n-icon [name]="'help'" [size]="'medium'" [scale]="'smaller'"  class="inline-block strategy-icon" (click)=strategyModalDialog.openModalDialog()></c11n-icon>
    </a>
  </h4>
  <c11n-radio-group groupId="strategy" variant="default" hideLegend="false"
                    legendText="{{ filterByLabHeader+' '+filter.assetCaas.strategy }}" (stateChange)="onFilterByChange($event)">
    <div class="storybook-horizontal-radios">
      <c11n-radio [labelText]=filter.assetCaas.dividend>
        <input c11nRadioInput id="dividend" type="radio" name="assetClass" [value]=filter.assetCaas.dividend
               [checked]=filter.filterByLevel1.dividend.value />
      </c11n-radio>
      <c11n-radio [labelText]=filter.assetCaas.esg>
        <input c11nRadioInput id="esg" type="radio" name="assetClass" [value]=filter.assetCaas.esg
               [checked]=filter.filterByLevel1.esg.value />
      </c11n-radio>
      <c11n-radio [labelText]=filter.assetCaas.factorDriven>
        <input c11nRadioInput id="factorDriven" type="radio" name="assetClass" [value]=filter.assetCaas.factorDriven
               [checked]=filter.filterByLevel1.factorDriven.value />
      </c11n-radio>
      <c11n-radio [labelText]=filter.assetCaas.sector>
        <input c11nRadioInput id="sectorSpecialties" type="radio" name="assetClass"
               [value]=filter.assetCaas.sector [checked]=filter.filterByLevel1.sectorSpecialties.value />
      </c11n-radio>
    </div>
  </c11n-radio-group>
</div>

<c11n-modal-dialog
  [modalId]="'strategyModalDialog'"
  [variant]="'basic'"
  [headingText]="strategiespopupHeader"
  [useContentWidth]="useContentWidth"
  [maxWidth]=1000
  [useContentWidth]= false
  #strategyModalDialog class="c11n-text-3xl-headline"
>
  <div
    [ngClass]="useContentWidth ? 'dialog-example-content-width' : 'dialog-example-default-width'"
    c11n-modal-dialog-body>
    <p [innerHTML]="fd3popupsList"></p>
  </div>
</c11n-modal-dialog>

